var _text, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spinnerLoaderRef",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    overflow: "visible",
    fill: "#ff5463",
    stroke: "#ff5463",
    className: "single-loader",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "spinner",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    y: 20
  }, "\uD83D\uDCA9")))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.08s",
    repeatCount: "indefinite"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.16s",
    repeatCount: "indefinite"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.24s",
    repeatCount: "indefinite"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.32s",
    repeatCount: "indefinite"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.4s",
    repeatCount: "indefinite"
  }))), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.48s",
    repeatCount: "indefinite"
  }))), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.56s",
    repeatCount: "indefinite"
  }))), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.64s",
    repeatCount: "indefinite"
  }))), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.72s",
    repeatCount: "indefinite"
  }))), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.8s",
    repeatCount: "indefinite"
  }))), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "1s",
    begin: "0.88s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLoader);
export default __webpack_public_path__ + "static/media/my-loader.7df3fdd4dff82fcadd93558b83de7489.svg";
export { ForwardRef as ReactComponent };